import { useState } from "react";
import type { PlacementPresentation } from "@townsy/contracts";
import { isApprovedMediaUrl } from "../advertise/media";

/**
 * Logo tile for a listing: the approved logo (`logoTextureUrl`, a padded square derivative served
 * same-origin from `/api/v1/media/`, ADR-0009 #2) on a neutral pad, or the monogram on the brand
 * colour when there is none, while it loads, or when it fails. The image is never recoloured.
 */
export function LogoTile({
  placement,
  size = "md",
  fallback = "?",
  title,
}: {
  placement: PlacementPresentation | null | undefined;
  size?: "md" | "lg";
  fallback?: string;
  title?: string;
}) {
  const [failed, setFailed] = useState<string | null>(null);
  const cls = `logo-tile${size === "lg" ? " lg" : ""}`;
  if (!placement) {
    return (
      <div className={cls} style={{ background: "#8a94a6" }} aria-hidden="true" title={title}>
        {fallback}
      </div>
    );
  }
  const url = isApprovedMediaUrl(placement.logoTextureUrl) && failed !== placement.logoTextureUrl ? placement.logoTextureUrl : null;
  if (url) {
    return (
      <div className={`${cls} logo-tile-image`} role="img" aria-label={`${placement.businessName} logo`} title={title}>
        <img src={url} alt="" width={56} height={56} loading="lazy" decoding="async" draggable={false} onError={() => setFailed(url)} />
      </div>
    );
  }
  return (
    <div className={cls} style={{ background: placement.brandColor }} role="img" aria-label={`${placement.businessName} logo`} title={title}>
      {placement.monogram}
    </div>
  );
}
